import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  clients: null,
  projects: null,
  commodities: null,
  testingTypes: null,
};

const dashboardFilterSlice = createSlice({
  name: "dashboardFilter",
  initialState,
  reducers: {
    fetchClients: (state, action) => {
      state.loading = true;
      state.clients = null;
    },
    fetchClientsSuccess: (state, action) => {
      state.loading = false;
      state.clients = action.payload?.data?.document;
    },
    fetchClientsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchProjects: (state, action) => {
      state.loading = true;
      // Don't clear projects to avoid flickering
    },
    fetchProjectsSuccess: (state, action) => {
      state.loading = false;
      state.projects = Array.isArray(action.payload)
        ? action.payload
        : action.payload?.data;
    },
    fetchProjectsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "Failed to fetch projects";
    },
    clearProjects: (state) => {
      state.projects = null;
    },
    // Commodity actions
    fetchCommodities: (state, action) => {
      state.loading = true;
    },
    fetchCommoditiesSuccess: (state, action) => {
      state.loading = false;
      state.commodities = action.payload?.data?.document;
    },
    fetchCommoditiesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Testing types actions
    fetchTestingTypes: (state, action) => {
      state.loading = true;
    },
    fetchTestingTypesSuccess: (state, action) => {
      state.loading = false;
      state.testingTypes = action.payload?.data?.document;
    },
    fetchTestingTypesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "Failed to fetch testing types";
    },
  },
});

export const { actions, reducer, name: sliceKey } = dashboardFilterSlice;